import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About us",
      contact: "Contact",
      cta: "Get Support",
    },
    common: {
      learnMore: "Learn more",
      readMore: "Read more",
      getStarted: "Start a conversation",
      loading: "Sending…",
      language: "Language",
      theme: "Theme",
      toggleTheme: "Toggle theme",
      toggleLang: "Change language",
      english: "English",
      bulgarian: "Български",
    },
    home: {
      overline: "",
      title1: "Founder-led technical support",
      title2: "for B2B SaaS teams.",
      sub: "A newly launched support partner based in Bulgaria. Tier 1 and Tier 2 coverage for growing SaaS companies that care about clear customer communication, structured ticket handling and real technical troubleshooting.",
      ctaPrimary: "Book a discovery call",
      ctaSecondary: "Explore services",
      stats: [
        { k: "Tier 1 · 2", v: "Support coverage" },
        { k: "EN · BG", v: " Languages" },
        { k: "Burgas, BG", v: "Where we are based" },
        { k: "Founder-led", v: "Hands-on from day one" },
      ],
      pillars: {
        title: "Structured support for SaaS teams that care about the details",
        sub: "Practical experience in software support and IT service desk environments working inside your tools, not around them.",
        items: [
          {
            tag: "T1",
            title: "Tier 1 Support",
            desc: "Ticket triage, first-response, clear customer communication and KB-driven resolution the front door to your product, handled calmly.",
          },
          {
            tag: "T2",
            title: "Tier 2 Support",
            desc: "Technical troubleshooting, log review, API request / response analysis and FTP / SFTP investigation, with reproducible cases ready for engineering.",
          },
          {
            tag: "INC",
            title: "Incident Handling & Escalation",
            desc: "Structured incident response with priority triage and clean, context-rich escalation to L2 / L3 or engineering teams.",
          },
          {
            tag: "DOC",
            title: "Process & Documentation",
            desc: "Runbooks, SOPs, internal knowledge base upkeep, ticket hygiene and handover notes that future-you will actually thank you for.",
          },
          {
            tag: "OPS",
            title: "Tools we plug into",
            desc: "Hands-on experience with Jira, ServiceNow, Zendesk and Salesforce we work inside your existing stack without forcing new tooling.",
          },
        ],
      },
      process: {
        title: "How we plug in",
        sub: "Low-friction onboarding. Measurable outcomes from week one.",
        steps: [
          { n: "01", t: "Discovery", d: "A call to understand your product, your customers and the shape of your current support load." },
          { n: "02", t: "Runbooks & SOPs", d: "We co-author playbooks, triage rules and escalation paths tailored to your team and tools." },
          { n: "03", t: "Pilot", d: "A short pilot on a slice of your tickets fully measured, honest feedback, no long lock-in." },
          { n: "04", t: "Roll-out", d: "Scale up to the agreed coverage with regular reviews and continuous process improvement." },
        ],
      },
      cta: {
        title: "Ready to hand off the support load?",
        sub: "Tell us about your product and your tickets we will tell you exactly how we would help.",
        btn: "Contact the founder",
      },
    },
    services: {
      overline: "",
      title: "Tier 1 & Tier 2 support, done properly",
      sub: "Pick one service or combine them into a structured support function. We adapt to your tools Jira, ServiceNow, Zendesk, Salesforce   and to the way your customers actually talk.",
      pilot: {
        title: "Start with a focused 30-day support pilot",
        sub: "A low-risk way to test whether MATO Systems fits your team.",
        whatWeCanPilot: "What we can pilot:",
        pilotItems: [
          "a defined slice of your ticket queue;",
          "Tier 1 triage and first response;",
          "Tier 2 investigation before escalation;",
          "ticket tagging and hygiene;",
          "support documentation improvements;",
          "weekly reporting on ticket themes and escalation quality."
        ],
        pilotOutputs: "Pilot outputs:",
        outputItems: [
          "cleaner tickets;",
          "better escalation context;",
          "recurring issue patterns;",
          "support-process improvement suggestions;",
          "honest recommendation on whether to scale."
        ]
      }
    },
    about: {
      overline: "",
      title: "A founder-led support partner from Bulgaria",
      sub: "A newly launched, founder-led practice so the person reading your ticket is the same person you meet on the first call. Small on purpose.",
      mission: {
        title: "Our mission",
        body: "Bring calm, structured and technically literate support to growing SaaS companies   founder's standard of care, without the overhead of a large agency.",
      },
      why: {
        title: "Why teams work with us",
        items: [
          { t: "Founder-led", d: "You talk to the person doing the work. No hand-offs, no layers   hands-on ownership from day one." },
          { t: "Real tooling experience", d: "Practical work in Jira, ServiceNow, Zendesk and Salesforce   plus ticket triage, incident handling and structured escalation." },
          { t: "Bilingual by default", d: "Native English and Bulgarian coverage, with clear written communication in both languages." },
          { t: "Technical, not scripted", d: "Log review, API request / response analysis, FTP / SFTP troubleshooting   we dig into the actual problem before escalating." },
        ],
      },
      team: {
        title: "Todor Slavov | Co-founder",
        sub: "Experience in B2B SaaS and regulated platform support environments, including work with Zendesk, Salesforce, Jira, Slack, ServiceNow, APIs, HTML/CSS, Active Directory, remote desktop, and structured escalation.",
      },
    },
    contact: {
      overline: "",
      title: "Let's talk support",
      sub: "Fill in the form or email us directly. We reply within one business day.",
      info: {
        email: "Email",
        phone: "Phone",
        address: "Headquarters",
        hours: "Support hours",
        hoursValue: "Burgas, Bulgaria GMT+3 · extended by agreement",
      },
      form: {
        name: "Full name",
        email: "Work email",
        subject: "Subject",
        message: "How can we help?",
        submit: "Send message",
        success: "Thanks   we received your message and will reply within one business day.",
        error: "Something went wrong. Please try again or email us directly.",
        namePh: "Jane Developer",
        emailPh: "jane@company.com",
        subjectPh: "L2 support for our SaaS",
        messagePh: "Tell us a little about your product, your users and the volume of support you need…",
      },
    },
    footer: {
      tagline: "Founder-led Tier 1 and Tier 2 support for B2B SaaS teams. Based in Burgas, Bulgaria.",
      sections: {
        company: "Company",
        services: "Services",
        contact: "Contact",
      },
      rights: "All rights reserved.",
    },
  },
  bg: {
    nav: {
      home: "Начало",
      services: "Услуги",
      about: "За нас",
      contact: "Контакти",
      cta: "Заяви поддръжка",
    },
    common: {
      learnMore: "Научи повече",
      readMore: "Виж повече",
      getStarted: "Започни разговор",
      loading: "Изпращане…",
      language: "Език",
      theme: "Тема",
      toggleTheme: "Смени темата",
      toggleLang: "Смени езика",
      english: "English",
      bulgarian: "Български",
    },
    home: {
      overline: "",
      title1: "Техническа поддръжка, водена от основателите,",
      title2: "за B2B SaaS екипи.",
      sub: "Новосъздаден support партньор, базиран в България. Tier 1 и Tier 2 покритие за растящи SaaS компании, които държат на ясна клиентска комуникация, структурирано обработване на тикети и истинско техническо отстраняване на проблеми.",
      ctaPrimary: "Запази среща",
      ctaSecondary: "Разгледай услугите",
      stats: [
        { k: "Tier 1 · 2", v: "Покритие на поддръжка" },
        { k: "EN · BG", v: "Езици" },
        { k: "Бургас, BG", v: "Къде сме" },
        { k: "Founder-led", v: "Лично ангажирани от ден 1" },
      ],
      pillars: {
        title: "Структурирана поддръжка за SaaS екипи с внимание към детайла",
        sub: "Практически опит в поддръжката на софтуер и в ИТ поддръжка, работим с инструментите ви, а не около тях.",
        items: [
          { tag: "T1", title: "Tier 1 поддръжка", desc: "Триаж на тикети, първоначален отговор, ясна клиентска комуникация и решение чрез knowledge base   входната врата към вашия продукт, водена спокойно." },
          { tag: "T2", title: "Tier 2 поддръжка", desc: "Техническо отстраняване на проблеми, преглед на логове, анализ на API request / response и FTP / SFTP, с възпроизводими случаи, готови за engineering." },
          { tag: "INC", title: "Incident Handling & ескалация", desc: "Структуриран incident response с приоритетен триаж и чиста, контекстно богата ескалация към L2 / L3 или engineering екипи." },
          { tag: "DOC", title: "Процеси и документация", desc: "Runbook-ове, SOP-и, поддръжка на вътрешна knowledge base, ticket hygiene и handover notes   каквито бъдещото ви „аз“ наистина ще оцени." },
          { tag: "OPS", title: "Инструменти, с които работим", desc: "Практически опит с Jira, ServiceNow, Zendesk и Salesforce   работим със съществуващия ви стек, без да налагаме нови инструменти." },
        ],
      },
      process: {
        title: "Как се включваме",
        sub: "Лесен старт. Измерими резултати още от първата седмица.",
        steps: [
          { n: "01", t: "Discovery", d: "30-минутен разговор, за да разберем продукта, клиентите и формата на текущото ви support натоварване." },
          { n: "02", t: "Runbook-ове и SOP-и", d: "Заедно създаваме плейбукове, правила за триаж и ескалация, съобразени с екипа и инструментите ви." },
          { n: "03", t: "Пилот", d: "Кратък пилот върху част от тикетите   напълно измерен, с честна обратна връзка, без дълъг ангажимент." },
          { n: "04", t: "Разгръщане", d: "Мащабиране до уговореното покритие, с редовни прегледи и непрекъснато подобряване на процесите." },
        ],
      },
      cta: {
        title: "Готови ли сте да делегирате поддръжката?",
        sub: "Разкажете ни за продукта и тикетите си   ще ви кажем точно как бихме помогнали.",
        btn: "Свържете се с нас",
      },
    },
    services: {
      overline: "",
      title: "Tier 1 и Tier 2 поддръжка, направена както трябва",
      sub: "Изберете една услуга или ги комбинирайте в структурирана support функция. Адаптираме се към инструментите ви   Jira, ServiceNow, Zendesk, Salesforce   и към начина, по който клиентите ви наистина говорят.",
      pilot: {
        title: "Започнете с фокусиран 30-дневен пилотен период за поддръжка",
        sub: "Нискорисков начин да проверите дали MATO Systems е подходящ за вашия екип.",
        whatWeCanPilot: "Какво можем да включим в пилота:",
        pilotItems: [
          "определена част от вашата опашка с тикети;",
          "първично обработване (Tier 1) и първи отговор;",
          "разследване на ниво Tier 2 преди ескалация;",
          "тагване и поддържане на качеството на тикетите;",
          "подобрения в документацията за поддръжка;",
          "седмични отчети за основните теми в тикетите и качеството на ескалациите."
        ],
        pilotOutputs: "Резултати от пилота:",
        outputItems: [
          "по-ясно структурирани тикети;",
          "по-добър контекст при ескалации;",
          "откриване на повтарящи се проблеми;",
          "предложения за подобрение на процесите по поддръжка;",
          "обективна препоръка дали да се разшири обхватът."
        ]
      }
    },
    about: {
      overline: "",
      title: "Support партньор от България, воден от основателя",
      sub: "Новосъздадена фирма, ръководена от нейните основатели, така че човекът, който разглежда заявката ви, е същият, с когото ще разговаряте при първия телефонен разговор. Умишлено малка по размер.",
      mission: {
        title: "Нашата мисия",
        body: "Осигуряваме спокойна, добре организирана и технически компетентна подкрепа, отговаряща на стандартите за грижа на разрастващи се SaaS компании, без разходите, свързани с голяма агенция.",
      },
      why: {
        title: "Защо екипите работят с нас",
        items: [
          { t: "Founder-led", d: "Говорите с човека, който върши работата. Без препращания, без слоеве   лично ангажирано отношение от ден 1." },
          { t: "Реален опит с инструментите", d: "Практическа работа с Jira, ServiceNow, Zendesk и Salesforce   плюс триаж на тикети, incident handling и структурирана ескалация." },
          { t: "Двуезични по подразбиране", d: "Английски и Български, с ясна писмена комуникация и на двата езика." },
          { t: "Технично, не скриптово", d: "Преглед на логове, анализ на API request / response, FTP / SFTP отстраняване   влизаме в реалния проблем, преди да ескалираме." },
        ],
      },
      team: {
        title: "Тодор Славов | Съосновател",
        sub: "Опит в поддръжката на B2B SaaS и регулирани платформи, включително работа със Zendesk, Salesforce, Jira, Slack, ServiceNow, API, HTML/CSS, Active Directory, отдалечен работен плот и структурирана ескалация.",
      },
    },
    contact: {
      overline: "",
      title: "Да поговорим за поддръжка",
      sub: "Попълнете формата или ни пишете директно. Отговаряме до един работен ден.",
      info: {
        email: "Имейл",
        phone: "Телефон",
        address: "Централен офис",
        hours: "Работно време",
        hoursValue: "Работно време Бургас GMT+3 · разширено по договорка",
      },
      form: {
        name: "Име и фамилия",
        email: "Служебен имейл",
        subject: "Тема",
        message: "Как можем да помогнем?",
        submit: "Изпрати",
        success: "Благодарим   получихме съобщението ви и ще отговорим до един работен ден.",
        error: "Нещо се обърка. Моля, опитайте отново или ни пишете директно.",
        namePh: "Име и фамилия",
        emailPh: "email@company.com",
        subjectPh: "L2 поддръжка за нашия SaaS",
        messagePh: "Разкажете ни за продукта, потребителите и обема поддръжка, от която имате нужда…",
      },
    },
    footer: {
      tagline: "",
      sections: {
        company: "Компания",
        services: "Услуги",
        contact: "Контакти",
      },
      rights: "Всички права запазени.",
    },
  },
};

const I18nContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("mato-lang") || "en";
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    try {
      localStorage.setItem("mato-lang", next);
      document.documentElement.lang = next;
    } catch (_) {}
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let cur = translations[lang] || translations.en;
      for (const p of parts) {
        if (cur == null) return path;
        cur = cur[p];
      }
      return cur ?? path;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
